import { ArrowRight } from '@mui/icons-material';
import { Avatar, Button, Link, ListItemText, MenuItem, Skeleton, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ITheme } from 'theme/types';

const wrapTextStyles = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
};

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: 'transparent',
  border: `2px solid ${theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.22) : '#fff'}`,
  fontWeight: 700,
  fontSize: '1rem',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    ...wrapTextStyles,
    color: theme.palette.mode === 'dark' ? '#e8e8e8' : theme.palette.common.white,
    fontWeight: 700,
  },
  '& .MuiListItemText-secondary': {
    ...wrapTextStyles,
    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.50)' : 'rgba(255,255,255,0.75)',
  },
}));

export const SecondaryLink = styled(Link)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.50)' : 'rgba(255,255,255,0.80)',
  textTransform: 'none',
  fontWeight: 'normal',
  fontSize: '0.8rem',
  justifyContent: 'flex-start',
  padding: `${theme.spacing(0.2)} 0`,
  marginTop: theme.spacing(0.5),
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.50)' : 'rgba(255,255,255,0.80)',
  textTransform: 'none',
  fontWeight: 'normal',
  fontSize: '0.8rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  display: 'flex',
  padding: `${theme.spacing(0.2)} 0`,
  marginTop: theme.spacing(0.5),
  gap: theme.spacing(0.75),

  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.40)' : 'rgba(255,255,255,0.70)',
}));

export const MenuItemsLabel = styled(MenuItem)(({ theme }) => ({
  fontFamily: (theme as unknown as ITheme).typography.secondaryFont,
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent
  lineHeight: '16px',
  textTransform: 'uppercase',
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: (theme as unknown as ITheme).typography.secondaryFont,
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1rem',
  lineHeight: '30px',
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.12) : 'rgba(0,0,0,0.08)',
}));
